
import ERROR_CODES from './errorCodes'

/**
 * Query Github's api with a graphql query.
 * @param {string} query
 * @returns {Promise<object>}
 */
export default function(authToken, query, variables){
  return fetch(`https://api.github.com/graphql`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${authToken}`,
    },
    method: 'post',
    body: JSON.stringify({
      query,
      variables,
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data['message']){
      var error = new Error(data['message'])
      error.uri = data['documentation_url']
      error.code = ERROR_CODES.GITHUB_GRAPH_QL_ERROR
      throw error
    }
    if (data['errors'] && data['errors'].length >= 1){
      // Throw the first error
      var error = new Error(data['errors'][0]['message'])
      error.code = ERROR_CODES.GITHUB_GRAPH_QL_ERROR
      throw error
    }
    return data
  })
}


// WEBPACK FOOTER //
// ./src/lib/askGithub.js